import { saveAs } from 'file-saver';

export const downloadBlob = (blob: Blob, filename: string) => {
  try {
    saveAs(blob, filename);
  } catch (error) {
    console.error('Error downloading file:', error);
    // Fallback method
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
};

export const generateFilename = (
  game: string,
  gameType: string,
  date?: string,
  isCustomRange?: boolean
): string => {
  const sanitizedGame = game.replace(/[^a-zA-Z0-9]/g, '_');
  const sanitizedGameType = gameType.replace(/[^a-zA-Z0-9]/g, '_');
  
  if (isCustomRange) {
    return `${sanitizedGame}_${sanitizedGameType}_custom_${new Date().toISOString().split('T')[0]}.csv`;
  }
  
  if (date) {
    return `${sanitizedGame}_${sanitizedGameType}_${date}.csv`;
  }
  
  return `${sanitizedGame}_${sanitizedGameType}_${new Date().toISOString().split('T')[0]}.csv`;
};
